module.exports = __webpack_public_path__ + "static/img/homeBusiness1.94593ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homeBusiness1.png
// module id = AevH
// module chunks = 3